import React, { useRef } from "react";
import { motion } from "framer-motion";
import html2pdf from "html2pdf.js";
import {valores} from "../data/Valores.ts"; 

const Valores: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);

  const generarPDF = () => {
    if (contentRef.current) {
      html2pdf().from(contentRef.current).save("valores_institucionales.pdf");
    }
  };

  const imprimir = () => {
    if (contentRef.current) {
      const printContent = contentRef.current.innerHTML;
      const win = window.open("", "_blank");
      if (win) {
        win.document.write(`
          <html>
            <head>
              <title>Imprimir Valores</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; }
                h1 { text-align: center; color: #1e3a8a; }
                h2 { color: #dc2626; }
                ul { padding-left: 20px; }
              </style>
            </head>
            <body>${printContent}</body>
          </html>
        `);
        win.document.close();
        win.print();
      }
    }
  };

  return (
    <motion.div
      className="min-h-screen py-12 px-6 bg-gradient-to-br from-blue-50 via-white to-red-50 mt-16"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="flex justify-between items-center max-w-7xl mx-auto mb-6">
        <h1 className="text-4xl font-bold text-blue-800 text-center w-full">
          Matriz de Valores Institucionales
        </h1>
      </div>

      <div className="flex justify-end gap-4 max-w-7xl mx-auto mb-6">
        <button
          onClick={generarPDF}
          className="bg-red-500 text-white px-4 py-2 rounded-xl shadow hover:bg-red-600 transition"
        >
          Descargar PDF
        </button>
        <button
          onClick={imprimir}
          className="bg-blue-500 text-white px-4 py-2 rounded-xl shadow hover:bg-blue-600 transition"
        >
          Imprimir
        </button>
      </div>

      <div
        ref={contentRef}
        className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto"
      >
        {valores.map((valor) => (
          <div
            key={valor.nombre}
            className="bg-white rounded-2xl shadow-md border border-blue-100 p-6 hover:shadow-lg transition"
          >
            <h2 className="text-xl font-semibold text-red-600 mb-4">
              {valor.nombre}
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              {valor.actitudes.map((actitud, idx) => (
                <li key={idx}>{actitud}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default Valores;
